import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { requireNotNull } from '@shared/pipes/require-not-null'
import { RegionalPagesPath, regionalPagesProps } from 'regions/runtime-components/pages-props'

import { NewLPScreen } from '../../../screens/new-lp'
import { serverSideResolveCity } from '../../../ssr-resolvers/next-ssr-resolvers'

const LoanMkkPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	NewLPScreen({
		ratePoints: [
			'Низкие ставки',
			'Без подтверждения дохода',
			'Одобрение за 30 минут',
			'Никаких брокерских комиссий',
			'Без поручителей',
			'Все расходы по сделке — на нас',
		],
		rateButtonText: 'Получить заём сейчас',
		mainBlockPath: {
			title: 'Заём под залог квартиры или авто по низкой ставке',
			footDisclaimer: null,
			textItems: [
				'Деньги на любые цели',
				'Срок — до 20 лет',
				'Работаем под надзором Банка России',
				'Вы остаетесь собственником',
			],
			subtitle: 'Займы от 500 тысяч рублей',
		},
		titleGetLoan: '3 простых шага для получения займа',
		minLoan: 5e5,
		hideOffers: true,
		leadProductType: 'REAL_ESTATE_LOAN',
		applicationFormTitle: 'Заявка на заём',
		applicationFormProgressTitle: 'Вероятность одобрения займа',
	})
const pageProps = requireNotNull(regionalPagesProps[RegionalPagesPath.loanMkk])
LoanMkkPage.layout = pageProps.layout
LoanMkkPage.headProps = pageProps.headProps

export const getServerSideProps = serverSideResolveCity

export default LoanMkkPage
